export default __webpack_public_path__ + "static/media/free-account.f8b7cef8.svg";